module.exports = __webpack_public_path__ + "img/dur-on.eb6f0f38.svg";